<mat-label *ngIf="productSpecificationNodes.length !== 0" class="specifications-field-label">Specification</mat-label>
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="product-specification-tree">

  <!-- This is the tree node when the node has no children -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
    <div class="mat-tree-node" [class.first-level]="!node.parent">
      <button type="button" mat-icon-button [disabled]="readOnly || !node.productSpecification.selectable" (click)="toggleNodeSelection(node)">
        <!-- Add check mark icon if node is selected -->
        <mat-icon *ngIf="node.selected">check_box</mat-icon>
        <!-- Add empty icon if node is not selected -->
        <mat-icon *ngIf="!node.selected">check_box_outline_blank</mat-icon>
      </button>
      {{node.productSpecification.name}}
    </div>
  </mat-tree-node>

  <!-- This is the tree node template for each node -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
    <div class="mat-tree-node" [class.first-level]="!node.parent">
      <button type="button" mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.productSpecification.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>
      <button type="button" mat-icon-button [disabled]="readOnly || !node.productSpecification.selectable" (click)="toggleNodeSelection(node)">
        <!-- Add check mark icon if node is selected -->
        <mat-icon *ngIf="node.selected">check_box</mat-icon>
        <!-- Add check mark icon if node is selected -->
        <mat-icon *ngIf="node.hasSelectedChildren()">indeterminate_check_box</mat-icon>
        <!-- Add empty icon if node is not selected -->
        <mat-icon *ngIf="!node.selected && !node.hasSelectedChildren()">check_box_outline_blank</mat-icon>
      </button>
      {{node.productSpecification.name}}
    </div>
    <div [class.product-specification-tree-invisible]="!treeControl.isExpanded(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
